import React from "react";
import mobileBanner from "../../assets/images/about/babu sleeping image 1024 1372.jpg";
import desktopBanner from "../../assets/images/about/Home Banner.png";

export default function AboutBanner() {
  return (
    <div className="relative w-full h-full">
      {/* Mobile Image (<1024px) */}
      <img
        src={mobileBanner}
        alt="About Banner Mobile"
        className="w-full h-full object-[100%] lg:hidden"
      />

      {/* Desktop Image (>=1024px) */}
      <img
        src={desktopBanner}
        alt="About Banner Desktop"
        className="w-full h-full hidden object-cover lg:block "
      />
    </div>
  );
}
